export const homeCategories = [
  {
    categoryId: "gaming_laptops",
    section: "ELECTRIC_CATEGORIES",
    name: "Gaming Laptop",
    image:
      "https://rukminim2.flixcart.com/image/312/312/xif0q/computer/x/9/j/-original-imahyjzh7m2zsqdg.jpeg?q=70",
  },
  {
    categoryId: "gaming_laptops",
    section: "ELECTRIC_CATEGORIES",
    name: "Office Laptop",
    image:
      "https://rukminim2.flixcart.com/image/312/312/xif0q/computer/x/9/j/-https://in-media.apjonlinecdn.com/catalog/product/cache/74c1057f7991b4edb2bc7bdaa94de933/c/0/c08531063_1.png-imahyjzh7m2zsqdg.jpeg?q=70",
  },
  {
    categoryId: "mobiles",
    section: "ELECTRIC_CATEGORIES",
    name: "Mobile",
    image:
      "https://rukminim2.flixcart.com/image/416/416/xif0q/mobile/5/t/j/edge-50-fusion-pb300002in-motorola-original-imahywzrfagkuyxx.jpeg?q=70&crop=false",
  },
  {
    categoryId: "smart_watches",
    section: "ELECTRIC_CATEGORIES",
    name: "Smartwatch",
    image:
      "https://rukminim2.flixcart.com/image/612/612/xif0q/smartwatch/f/g/g/-original-imagywnz46fngcks.jpeg?q=70",
  },
  {
    categoryId: "headphones_headsets",
    section: "ELECTRIC_CATEGORIES",
    name: "Headphones",
    image:
      "https://rukminim2.flixcart.com/image/612/612/kz4gh3k0/headphone/c/v/r/-original-imagb7bmhdgghzxq.jpeg?q=70",
  },
  {
    categoryId: "home_theatres",
    section: "ELECTRIC_CATEGORIES",
    name: "Speaker",
    image:
      "https://rukminim2.flixcart.com/image/612/612/xif0q/speaker/6/z/2/-original-imahfgfkr5gkk9aq.jpeg?q=70",
  },
  {
    categoryId: "television",
    section: "ELECTRIC_CATEGORIES",
    name: "Tv",
    image:
      "https://rukminim2.flixcart.com/image/312/312/xif0q/television/9/p/9/-original-imah2v29z86u7b79.jpeg?q=70",
  },
  {
    categoryId: "cameras",
    section: "ELECTRIC_CATEGORIES",
    name: "Camera",
    image:
      "https://rukminim2.flixcart.com/image/312/312/jfbfde80/camera/n/r/n/canon-eos-eos-3000d-dslr-original-imaf3t5h9yuyc5zu.jpeg?q=70",
  },
  {
    categoryId: "women_lehenga_cholis",
    section: "GRID",
    name: "women lehenga cholis",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/23807268/2023/6/29/9930b235-5318-4755-abbe-08f99e969e781688026636544LehengaCholi7.jpg",
  },
  {
    categoryId: "men_formal_shoes",
    section: "GRID",
    name: "men formal shoes",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/24651572/2023/8/25/4fbf6d8c-d093-46c5-a5a6-7dd67c0c76551692964752597HouseofPataudiMenTanFauxLeatherFormalSlipOnLoafers1.jpg",
  },
  {
    categoryId: "women_lehenga_cholis",
    section: "GRID",
    name: "women lehenga cholis",
    image:
      "https://images.pexels.com/photos/12730873/pexels-photo-12730873.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    categoryId: "men_sherwanis",
    section: "GRID",
    name: "men sherwanis",
    image:
      "https://shreeman.in/cdn/shop/files/20_3cfbd5a3-ecb6-482a-b798-7ffd9de1c784.jpg?v=1712061674&width=700",
  },
  {
    categoryId: "women_jewellery",
    section: "GRID",
    name: "women jewellery",
    image:
      "https://media.istockphoto.com/id/1276740597/photo/indian-traditional-gold-necklace.jpg?b=1&s=612x612&w=0&k=20&c=S-QnNZKqf2u3L-GIaDiIinNRU74GBWQaIDwY7gYJboY=",
  },
  {
    categoryId: "women_footwear",
    section: "GRID",
    name: "women footwear",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/13837166/2021/8/19/04e40e02-4c56-4705-94d0-f444b29973aa1629373611707-House-of-Pataudi-Women-Maroon-Embellished-Handcrafted-Wedges-1.jpg",
  },
  {
    name: "Home Décor",
    categoryId: "home_decor",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/28460938/2024/3/22/7fb09e9c-86e0-4602-b54e-fa5c0171b50b1711104156746IrregularMirrorHomeDecor1.jpg",
  },
  {
    name: "Kitchen & Table",
    categoryId: "kitchen_table",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19873492/2022/9/10/fd72939c-c379-4bab-9fd6-918c89172d161662797928387AquarelleBlue100CottonPrintedTableRunner1.jpg",
  },

  {
    parentCategoryId: "women",

    name: "Sports & Active Wear",
    categoryId: "women_sports_active_wear",
    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/22109480/2023/9/5/06a17ac3-46b0-4f9d-bcb1-2d3582feda041693895310152PumaWomenBrandLogoPrintedPureCottonOutdoorT-shirt1.jpg",
  },

  {
    parentCategoryId: "women",

    name: "Indian & fusion Wear",
    categoryId: "women_indian_and_fusion_wear",
    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22866694/2023/4/24/98951db4-e0a5-47f8-a1be-353863d24dc01682349679664KaliniOrangeSilkBlendEthnicWovenDesignFestiveSareewithMatchi2.jpg",
  },
  {
    parentCategoryId: "women",

    name: "western wear",
    categoryId: "women_western_wear",
    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/22391504/2023/3/17/3259c109-060a-4c39-aba2-e9d32e2068e41679049035856StyleQuotientPeach-ColouredTie-UpNeckPuffSleeveCottonTop1.jpg",
  },
  {
    name: "Topwere",
    categoryId: "men_topwear",
    parentCategoryId: "men",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/23029834/2023/9/18/96c015ae-1090-4036-954b-d9c80085b1d71695022844653-HRX-by-Hrithik-Roshan-Men-Jackets-6981695022843934-1.jpg",
  },
  {
    name: "Bottomwere",
    categoryId: "men_bottomwear",
    parentCategoryId: "men",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/20122324/2022/9/22/91c61c45-fe17-4d1d-8e20-0aaaf90186b61663827920015RaymondSlimFitBlueJeansForMen1.jpg",
  },
  {
    name: "Innerwere And Sleepwere",
    categoryId: "men_innerwear_and_sleepwear",
    parentCategoryId: "men",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/24528350/2023/8/17/d9ee03c9-7e15-49e4-8f15-0b6f38e568121692275415567TrackPants1.jpg",
  },
  {
    name: "Footwere",
    categoryId: "men_footwear",
    parentCategoryId: "men",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/27107914/2024/1/30/bd09f650-d8a4-4570-8e53-e2cfafc4ea6c1706609911015SparxMenMeshRunningShoes1.jpg",
  },
  {
    name: "Bed Linen & Furnishing",
    categoryId: "bed_linen_furnishing",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/19284508/2022/7/28/92df52de-27dc-4d72-8ab4-fee2c82c85081659003977664DreamscapeUnisexPinkBedsheets1.jpg",
  },
  {
    name: "Flooring",
    categoryId: "flooring",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/27868878/2024/2/25/53b7c07f-24a7-48e2-a791-f63dce4a0c981708844793060SANACARPETMulticolouredFloralAnti-SkidPolyesterCarpet1.jpg",
  },
  {
    name: "Bath",
    categoryId: "bath",

    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/16719378/2024/7/2/97418bad-8216-494f-a863-9b159aec93cf1719897710069JockeyPackof2CottonTerry500GSMUltrasoftandDurableSolidHandTo1.jpg",
  },
  {
    name: "Lamps & Lighting",
    categoryId: "lamps_lighting",
    section: "SHOP_BY_CATEGORIES",
    image:
      "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/productimage/2021/6/10/5be80654-037c-4591-99c9-a403646971981623344562713-1.jpg",
  },
  {
    name: "Men T Shirts",
    categoryId: "men_t_shirts",
    section: "DEALS",
    image: "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2024/AUGUST/26/zLmM5KEB_e4781ac0cc0945119e653f4130994bd2.jpg",
  },
  {
    name: "Women Skirts",
    categoryId: "women_skirts_palazzos",
    section: "DEALS",
    image: "https://rukminim2.flixcart.com/image/612/612/xif0q/skirt/k/o/h/free-1-00003-custom-fashion-original-imagztykafwbqupf.jpeg?q=70",
  },
  {
    name: "Men Formal Shirts",
    categoryId: "men_formal_shirts",
    section: "DEALS",
    image: "https://rukminim2.flixcart.com/image/612/612/xif0q/shirt/p/b/f/xl-new-fashion-cotton-shirts-for-men-solstice-original-imah3cqb7cak4nyp.jpeg?q=70",
  },
  
  {
    name: "Women Saree",
    categoryId: "women_sarees",
    section: "DEALS",
    image: "https://rukminim2.flixcart.com/image/832/832/xif0q/sari/z/a/4/free-saree-new2023-simple-light-weight-saree-chiffon-print-saree-original-imagzyhp2azy7rwz.jpeg?q=70&crop=false",
  },
  {
    name: "Smart Watches",
    categoryId: "smart_watches",
    section: "DEALS",
    image: "https://rukminim2.flixcart.com/image/416/416/xif0q/smartwatch/u/r/h/-original-imagyxxfgz52vzqn.jpeg?q=70&crop=false",
  },
  {
    name: "Men Festive Wear",
    categoryId: "men_indian_and_festive_wear",
    section: "DEALS",
    image: "https://rukminim2.flixcart.com/image/612/612/xif0q/ethnic-set/o/n/o/l-02-langit-original-imah4jwwctkjtman.jpeg?q=70",
  },
];
